<template>
    <tr>
        <td class="border-b border-gray-100 px-3 py-2.5 sm:px-4">
            <div class="flex items-center">
                <div
                    class="2xl:w-10 2xl:w-10 h-6 w-6 flex-shrink-0 self-start sm:h-8 sm:w-8"
                >
                    <img
                        v-if="item.image"
                        class="2xl:w-10 2xl:w-10 h-6 w-6 rounded-lg shadow-inner sm:h-8 sm:w-8 print:hidden"
                        :src="item.image + '-/resize/80x80/-/format/auto/'"
                        :alt="item.name"
                    />
                    <div
                        v-else
                        class="2xl:h-10 2xl:w-10 h-6 w-6 rounded-lg bg-gray-200 shadow-inner sm:h-8 sm:w-8 print:hidden"
                    />
                    <div
                        class="hidden h-8 w-8 rounded-md border border-gray-400 bg-gray-200 print:block"
                    />
                </div>
                <div class="ml-3">
                    <div class="text-sm font-medium leading-5 text-gray-900">
                        {{ item.name }}
                    </div>
                    <div v-if="item.modifiers?.length">
                        <div
                            v-for="(modifier, key) in item.modifiers"
                            :key="`${item.id}-${modifier.id}-${key}`"
                            class="ml-1 flex flex-row items-center text-gray-700"
                        >
                            <base-curved-arrow-icon
                                class="mr-1 h-3 w-3 rotate-180 transform-gpu"
                            />
                            <span
                                class="w-full pl-1 text-sm leading-5 text-green-600"
                            >
                                {{ modifier.name }}
                            </span>
                        </div>
                    </div>
                    <div
                        v-if="item?.notes?.length"
                        class="ml-1 mt-1 inline-flex flex-row items-center whitespace-normal rounded-md border border-dashed bg-gray-50 px-1 py-0.5"
                    >
                        <base-warning-icon
                            class="inline-block max-h-4 max-w-4 text-yellow-700"
                        />
                        <span class="pl-1 text-sm leading-5 text-gray-500">
                            {{ item.notes }}
                        </span>
                    </div>
                </div>
            </div>
        </td>
        <td
            class="whitespace-nowrap border-b border-gray-100 px-3 py-2.5 text-right sm:px-4"
            :class="[item.modifiers?.length ? 'align-top' : '']"
        >
            <div
                class="inline rounded-md bg-sk-silver-grey px-2 py-1 font-mono text-sm font-semibold leading-5 text-gray-900"
            >
                x{{ item.quantity }}
            </div>

            <template v-if="item.modifiers?.some(m => m.quantity > 1)">
                <div
                    v-for="(modifier, key) in item.modifiers"
                    :key="`${item.id}-${modifier.id}-${key}`"
                    class="ml-1 flex items-center justify-end text-gray-700"
                >
                    <span
                        class="rounded-md px-2 pl-1 text-xs leading-5 text-green-600"
                    >
                        x{{ modifier.quantity }}
                    </span>
                </div>
            </template>
        </td>
        <td
            :class="{
                'align-top': item.modifiers?.length
            }"
            class="whitespace-nowrap border-b border-gray-100 px-3 py-2.5 text-right font-mono sm:px-4"
        >
            <div class="text-sm leading-5 text-gray-900">
                {{ (countItemPrice(item) / 100) | currency }}
            </div>
        </td>
    </tr>
</template>

<script>
export default {
    name: 'OrderMenuItem',
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    methods: {
        countItemPrice(item) {
            let price = item.price * item.quantity;

            if (item.modifiers) {
                item.modifiers.map(modifier => {
                    price +=
                        modifier.price *
                        (modifier.quantity ?? 1) *
                        item.quantity;
                });
            }
            return price;
        }
    }
};
</script>
